module.exports = __webpack_public_path__ + "static/media/rocket.30382407.svg";